type MutableOption = {
  label: string;
  value: string;
  type: string[];
};

type UseMutableProps = {
  options: MutableOption[];
  callback: (option: MutableOption) => boolean;
};

const useMutableOptions = ({ options, callback }: UseMutableProps) => {
  const mutableOptions = options.filter((option) => callback(option));

  return mutableOptions;
};

export { useMutableOptions };
